
export interface ILocation {
  name:string;
  _id:string;
}


export const EMPTY_LOCATION:ILocation = {
  name:'',
  _id:'',
};
